jQuery(function ($) {
    $('.page-content').on('click', '.e-n-accordion-item .e-n-accordion-item-title[aria-expanded="false"]', function () {
        const $title = $(this);

        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $title.offset().top - 200
            }, 400);
        }, 500);
    });
});
